import type { FaireProductEntity } from "../../entity_types/product";

export const p_wp2fnfdgdp: FaireProductEntity = {
  token: "p_wp2fnfdgdp",
  type: "product",
  name: "Dusk in Eden Candle",
  brandToken: "b_xjywu3etzs",
  brandName: "Element Brooklyn",
  imageUrl:
    "https://cdn.faire.com/fastly/299c3d20071ab1ad443448be38c8b3eae0fcebfa175a31705998867e79e4bce1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30247db197f6df6c8489896b30d883889d4b41dc8004d1d7406a7c70bd55a365.jpeg",
    "https://cdn.faire.com/fastly/575e38e7a682db960894279077d7abf6cf31dc9a1b80300035a39bb6a1bbb1f6.jpeg",
    "https://cdn.faire.com/fastly/0df60ca9d4575f07625d7c5fc5b991794d1d7065ade385bbcb1b8bf19f77075a.jpeg",
    "https://cdn.faire.com/fastly/32b4907a5acc42fcca083aea70d172aac5ad71a9661e1cad821b53714c68fe33.png",
    "https://cdn.faire.com/fastly/ac48011679215df2227b76509da381969d1935f4ed75cfd9a8fefd221588c103.jpeg",
    "https://cdn.faire.com/fastly/831176583694f7943504f5062aa8b88a2fbce290f7ecadbcfe98104003ff3efd.jpeg",
  ],
  priceDollars: 17.6,
  description:
    "Twilight kaleidoscope. An ancient garden, forbidden fruit, secret desires. Reality, dream, and mythology, all at once.\n",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:59.619Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
